import { colors } from "@storeblocks/global-styles";
import { getBranding } from "./Themes/allThemes";
import styled from "styled-components";
export const VerticalLine = styled.div `
  background: ${(props) => props.active
    ? getBranding(props.branding).verticalLineBackground
    : colors.grey.grey40};
  grid-column: 1;
  grid-row: 1;
  height: 100%;
  margin: auto;
  min-height: ${(props) => (props.hasMinHeight ? "24px" : "0")};
  width: ${(props) => (props.active ? "3px" : "1px")};
`;
//# sourceMappingURL=styled.js.map